import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { first, map, Observable, tap } from 'rxjs';

import { LoginSessionFacadeService } from '../login-session-facade.service';

@Injectable({
  providedIn: 'root',
})
export class UniversalLoginGuard implements CanActivate {
  public isUniversalLogin: boolean;
  constructor(
    private router: Router,
    private authService: AuthService,
    private facade: LoginSessionFacadeService
  ) {}

  canActivate(): Observable<boolean> {
    return this.authService.isAuthenticated$.pipe(
      first(),
      tap((isAuthenticated) => {
        if (isAuthenticated) {
          this.router.navigate(['/']);
        } else {
          this.authService.loginWithRedirect({
            appState: { target: this.facade.getTargetUrl() },
          });
        }
      }),
      map(() => false)
    );
  }
}
